import { render, staticRenderFns } from "./errorPayment.vue?vue&type=template&id=0ea36fe8&scoped=true"
import script from "./errorPayment.vue?vue&type=script&lang=js"
export * from "./errorPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea36fe8",
  null
  
)

export default component.exports